import {
    SUB_PROFILES_FETCH,
    SUB_PROFILES_IS_FETCING,
    SUB_PROFILE_EDIT,
		SUB_PROFILE_FILTER,
		SINGLE_SUB_PROFILE_FETCH,
		SUB_PROFILES_ABS_REBATE_VALUES_FETCH
} from 'constants/subProfiles'

export default function subProfilesReducer(state = {
    list: [],
		singleSubProfileFetched: {},
		absoluteRebateValues: [],
    pageable: {
        sort: {
            'subProfileId': 'asc',
            'name': false,
            'markup': false,
            'commission': false,
            'spread': false,
            'percentage': false,
        },
        size: 10,
        page: 0,
        totalPages: 0,
        totalElements: 0,
    }
}, action) {
    switch (action.type) {
				case SUB_PROFILES_ABS_REBATE_VALUES_FETCH:
						return {
							...state,
							absoluteRebateValues: action.payload
						}
				case SINGLE_SUB_PROFILE_FETCH:
						return {
							...state,
							singleSubProfileFetched: action.payload
						}
        case SUB_PROFILES_FETCH:
            return {
                ...state,
                list: action.payload,
            }
        case SUB_PROFILE_EDIT:
            return {
                ...state,
            }
        case SUB_PROFILES_IS_FETCING:
            return {
                ...state,
                isFetching: action.payload,
            }
        case SUB_PROFILE_FILTER:
            return {
                ...state,
                pageable: {
                    ...state.pageable,
                    ...action.payload,
                    sort: action.payload.sort ? {
                        ...Object.keys(state.pageable.sort).reduce((obj, i) => ({
                            ...obj,
                            [i]: false
                        }), {}),
                        ...action.payload.sort
                    } : state.pageable.sort,
                },
            }
        default:
            return state
    }
}


// WEBPACK FOOTER //
// ./src/reducers/subProfiles.js